import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-control-teststeps-upload-evidence-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class ControlTestStepsUploadEvidenceApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.controlTestStepsUploadEvidenceApi"),
            httpMethod: "POST",
            path: "/controls/testing/advanced/effectiveness/automation/samples/{sampleGuid}/teststeps/{testStepGuid}/evidence",

            parameters: [
                {
                    name: "sampleGuid",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "testStepGuid",
                    description: this.translation.t("parameters.controlTestStepGuidDescription"),
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "evidence",
                    description: this.translation.t("parameters.controlEvidenceDescription"),
                    in: "formData",
                    paramType: "file",
                    required: true,
                    example: "binary",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "Request has been successfully processed",
                },
            ],
        };
    }
}
